import key from '@/api/key';
import login from '@/api/login'
import parkinglot from '@/api/parkinglot'
import order from '@/api/order';
import area from '@/api/area';

// 导出接口
export default {
  key,
  login,
  parkinglot,
  order,
  area
  // ……
}
